/**
 * Regular expression for valid US phone numbers
 * A valid phone number cannot have 0 or 1 as the first number of the "area code" or "office code"
 * For example, X or A in XXX-AAA-BBBB
 * Exception to this is made for area code 123, which is used for testing purposes.
 * This regex matches the stripped numeric-only format.
 * https://greenlightme.atlassian.net/wiki/spaces/GPD/pages/2018836555/Valid+Numbers
 * @type {Regexp} 222-333-4444
 */
const phoneNumberRegex = /^1?((123)|([2-9]\d{2}))[2-9]\d{2}\d{4}$/;

export function isValidPhoneNumber(unformattedPhoneNumber: string): boolean {
  if (
    unformattedPhoneNumber.length < 10 ||
    unformattedPhoneNumber.length > 11
  ) {
    return false; // Phone number must be 10 or 11 digits long
  }
  return unformattedPhoneNumber.match(phoneNumberRegex) !== null;
}

/**
 * Regular expression for a valid email address
 * @type {Regexp} user@greenlight.me
 */
export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validateParam = (param: string | null) => {
  const regex = /^[a-zA-Z0-9-_%@:.+#?&~ \/\\\\]+$/;
  return typeof param === 'string' && param !== '' && regex.test(param);
};
